"use strict";
/**
 * @ignore
 */

/** */

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.fetchAndDecode = exports.decodeWith = void 0;

var axios_1 = __importDefault(require("axios"));

var E = __importStar(require("fp-ts/lib/Either"));

var pipeable_1 = require("fp-ts/lib/pipeable");

var TE = __importStar(require("fp-ts/lib/TaskEither"));

var PathReporter_1 = require("io-ts/lib/PathReporter");

var fp_1 = require("./fp");
/**
 * Decode, and return an Error on failure
 *
 * @param codec - Codec used to decode
 */


function decodeWith(codec) {
  return function (response) {
    return TE.fromEither(pipeable_1.pipe(codec.decode(response), E.mapLeft(function (errors) {
      return new Error(PathReporter_1.failure(errors).join('\n'));
    })));
  };
}

exports.decodeWith = decodeWith;
/**
 * Fetch with axios from URL, and decode using io-ts
 *
 * @param url - The URL to fetch from
 * @param codec = The io-ts codec used for decoding
 * @param options - Additional options, e.g. error handling
 */

function fetchAndDecode(url, codec, options) {
  if (options === void 0) {
    options = {};
  }

  return pipeable_1.pipe(fp_1.promiseToTE(function () {
    return axios_1["default"].get(url).then(function (_a) {
      var data = _a.data;
      return data;
    })["catch"](function (error) {
      throw options.onError ? options.onError(error) : error;
    });
  }), TE.chain(decodeWith(codec)));
}

exports.fetchAndDecode = fetchAndDecode;